import { ComplaintAppointmentFiltersDTO } from "./complaint-appointment-filters.model";

export const complaintAppointmentListColumns = [
    'date',
    'created',
    'primaryKey'
] as const;
export type ComplaintAppointmentColumnKey = typeof complaintAppointmentListColumns[number];

export type ComplaintAppointmentColumnSortOrder = {
    column: ComplaintAppointmentColumnKey;
    order: 'asc' | 'desc' | null;
}[];

export interface ComplaintAppointmentRequestParams {
    userId: number;
    appVersion: string;
    filters: ComplaintAppointmentFiltersDTO;
    sort: ComplaintAppointmentColumnSortOrder;
    offset: number;
    limit: number; 
}